import { useEffect } from 'react';

const FINAL_TITLE = 'Paper Bridge';
// Per-tab flag so reloads keep the static title. The intro is a brand
// moment, not a feature — re-playing it on every reload would be noise.
const SESSION_KEY = 'pb-title-intro-played';

/**
 * One-time typewriter intro on the browser tab title.
 *
 * Plays once per tab session: types out "Paper Bridge" character by
 * character over ~700 ms, then settles. Subsequent reloads see the static
 * title immediately (sessionStorage flag), so it doesn't become noise.
 *
 * No-render component — mount once at the App root.
 */
export function AppTitle(): null {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (window.sessionStorage.getItem(SESSION_KEY) === '1') {
      document.title = FINAL_TITLE;
      return;
    }
    window.sessionStorage.setItem(SESSION_KEY, '1');

    let cancelled = false;
    const timers: ReturnType<typeof setTimeout>[] = [];

    const typeAt = (i: number, delay: number) => {
      timers.push(
        setTimeout(() => {
          if (cancelled) return;
          document.title = FINAL_TITLE.slice(0, i);
          if (i < FINAL_TITLE.length) typeAt(i + 1, 55);
        }, delay),
      );
    };

    // Start blank to make the first character feel like an entrance,
    // then type each character ~55 ms apart for ~700 ms total.
    document.title = '';
    typeAt(1, 140);

    return () => {
      cancelled = true;
      timers.forEach(clearTimeout);
      document.title = FINAL_TITLE;
    };
  }, []);

  return null;
}
